/**
 * API manzili uch bosqichda aniqlanadi:
 *   1. `public/config.js` dagi `window.__XSIB_PARTNER_API_BASE__` —
 *      serverda tahrirlanadi, build qayta yig'ilmaydi
 *   2. `VITE_API_BASE_URL` — build vaqtidagi qiymat
 *   3. bo'sh — so'rovlar "/api/..." ga ketadi (dev'da Vite proxy,
 *      serverda nginx backend'ga uzatadi)
 *
 * ⚠️ GLOBAL NOM HAR ILOVADA BOSHQA (`__XSIB_PARTNER_API_BASE__`): ikki
 * ilova bitta hostda turli portlarda ochilishi mumkin va
 * `docker-entrypoint.sh` har biri uchun o'z `config.js` ini yozadi.
 *
 * ⚠️ NEGA ALOHIDA MODUL. Qiymat IKKI axios nusxasiga kerak: `api` va
 * `refreshClient` (`sessionRefresh.ts` — ataylab interceptorsiz).
 * Ikkinchisi birinchisidan import qila olmaydi, aylanma bog'liqlik
 * hosil bo'lardi (`client.ts` → `sessionRefresh.ts` → `client.ts`).
 */
declare global {
  interface Window {
    __XSIB_PARTNER_API_BASE__?: string
  }
}

const runtimeBase = typeof window !== 'undefined' ? window.__XSIB_PARTNER_API_BASE__ : undefined

export const apiBaseUrl = (runtimeBase ?? import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/$/, '')

/**
 * ⚠️ MAJBURIY: axios standarti — `0`, ya'ni CHEKSIZ kutish. Server javob
 * bermasa promise hech qachon rad etilmaydi va ekran abadiy
 * "yuklanmoqda" holatida qoladi. Kassir uchun bu eng yomon holat: u pul
 * olib bo'lgan, natija esa noma'lum.
 */
export const API_TIMEOUT_MS = 15_000
